var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIcoArrowRight = function SvgIcoArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ico-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49",
    d: "M0 0v24h24V0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 3",
    d: "M5 11h11.586l-4.293-4.293a1 1 0 0 1 0-1.414 1 1 0 0 1 1.414 0l5.983 5.983a.988.988 0 0 1 .3.625V12.212l-.007.032v.015l-.01.034v.011l-.012.036v.01l-.014.035v.01l-.015.033-.008.017-.013.025-.016.029-.006.01a.989.989 0 0 1-.194.235l-5.958 5.962a1 1 0 0 1-1.414 0 1 1 0 0 1 0-1.414l4.291-4.293H5a1 1 0 0 1-1-1A1 1 0 0 1 5 11Z",
    fill: "#35272a"
  }))));
};

export default SvgIcoArrowRight;